import {
  Datagrid,
  Filter,
  FunctionField,
  PaginationLimit,
  ResourceContextProvider,
  SearchInput,
  TextField,
} from "react-admin";
import EmptyComponent from "../../subcontractorPurchaseInvoices/components/EmptyComponent";
import React from "react";
import { makeStyles } from "@material-ui/core";
import DetailButton from "./DetailButton";
import StatusField from "../../../components/StatusField";
import { getMonth } from "utils/tools";
import DownloadExcelButton from "./DownloadExcelButton";
import { PaddingDenseStyledList } from "../../../components/ListWrapper";
import ActionsMenu from "../../../components/ActionsMenu";
import CustomPagination from "../../../components/CustomPagination";
import ShowPdfButton from "./ShowPdfButton";
import DownloadMergedExcelButton from "./DownloadMergedExcelButton";

interface ISubcontractorPurchaseInvoiceSummaryTable {
  subcontractorId?: number;
  isFixedHeight?: boolean;
  referenceResource:
    | "subcontractorRouteTransactions"
    | "subcontractorPurchaseInvoices";
  isShowTitle?: boolean;
}

const useStyles = makeStyles({
  RaLists: {
    "& div:nth-child(2) > div": {
      marginTop: "0px",
    },
  },
});

const SubcontractorPurchaseInvoiceSummaryTableFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const SubcontractorPurchaseInvoiceSummaryTable = ({
  subcontractorId,
  isFixedHeight,
  referenceResource,
  isShowTitle,
}: ISubcontractorPurchaseInvoiceSummaryTable) => {
  const classes = useStyles();

  const isRouteTransaction =
    referenceResource === "subcontractorRouteTransactions";

  const statusIn =
    referenceResource === "subcontractorRouteTransactions"
      ? ["Pending", "ReadyToApprove"]
      : ["GeneratingSubcontractorPurchaseInvoice","ReadyToApprove", "Approved"];

  return (
    <ResourceContextProvider value="subcontractorPurchaseInvoiceSummaries">
      <PaddingDenseStyledList
        basePath="/subcontractorPurchaseInvoiceSummaries"
        className={classes.RaLists}
        actions={null}
        exporter={false}
        hasCreate={false}
        bulkActionButtons={false}
        filters={<SubcontractorPurchaseInvoiceSummaryTableFilter />}
        filterDefaultValues={{
          StatusIn: statusIn,
        }}
        sort={{ field: "id", order: "DESC" }}
        title={
          isShowTitle
            ? isRouteTransaction
              ? "Subcontractor Route Transactions"
              : "Subcontractor Purchase Invoices"
            : " "
        }
        pagination={
          <CustomPagination
            limit={isFixedHeight ? <EmptyComponent /> : <PaginationLimit />}
          />
        }
      >
        <Datagrid>
          <TextField source="id" emptyText="-" />
          <FunctionField
            label="Period"
            render={(record: any) =>
              `${getMonth(record.month)} - ${record.year}`
            }
          />
          <StatusField source="status" />
          <FunctionField
            label="Actions"
            render={(record: any) => {
              if (record.status === "generating_subcontractor_purchase_invoice") {
                return <span>Generating Subcontractor Purchase Invoice… Please refresh the page periodically.</span>;
              }

              return (
                <ActionsMenu
                  numberOfActions={4}
                  render={[
                    <DetailButton
                      purchaseInvoiceSummaryId={record.id}
                      subcontractorId={subcontractorId}
                      referenceResource={referenceResource}
                    />,
                    record.pdfUrl && <ShowPdfButton id={record.id} />,
                    !isRouteTransaction && record.status !== "pending" && (
                      <DownloadMergedExcelButton
                        purchaseInvoiceSummaryId={record.id}
                        period={`${record.year}${record.month}`}
                      />
                    ),
                    !isRouteTransaction && record.status !== "pending" && (
                      <DownloadExcelButton
                        purchaseInvoiceSummaryId={record.id}
                        period={`${record.year}${record.month}`}
                      />
                    ),
                  ]}
                />
              );
            }}
          />
        </Datagrid>
      </PaddingDenseStyledList>
    </ResourceContextProvider>
  );
};

export default SubcontractorPurchaseInvoiceSummaryTable;
